import { RootState } from './types'

export const getStoreSelector = (state: RootState) => state.clinicsCategory
